import mock from '../MockConfig';
import crypto from '../../db/dashboard/crypto';

// Define all mocks of dashboard

mock.onGet("/dashboard/dashboard").reply(200, crypto);
